module.exports = __webpack_public_path__ + "img/月亮_moon.f5320ea9.png";